import { PagedResultDto } from "@services/dto/pagedResultDto"
import http from "../httpService"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import { CustomerModel } from "@models/customer/customerModel"

class GroupService {
  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Group/GetAll", { params })
    return res.data.result
  }
  public async getAllCustomersByGroup(
    params: any
  ): Promise<PagedResultDto<any>> {
    const res = await http.get(
      "api/services/app/ExistingCustomer/GetAllByGroup",
      {
        params,
      }
    )
    const { result } = res.data
    return CustomerModel.assign(result)
  }

  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/Group/Get", {
      params: { id },
    })
    const { result } = res.data
    return result
  }

  public async createOrUpdate(body: any) {
    const res = await http.post("api/services/app/Group/CreateOrUpdate", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }
  public async activate(id: number, isActive) {
    const res = await http.post(
      "api/services/app/Group/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }
  public async getList(): Promise<any> {
    const res = await http.get("api/services/app/Group/GetList")
    const { result } = res.data
    return result
  }
}

export default new GroupService()
